export const DESIGNER_CONTAINER = 'designer-container';
export const VIEWER_CONTAINER = 'viewer-container';
